export default __webpack_public_path__ + "static/loading-anim-8a9474598f1f790c36295bbb8090beff.mp4";